export const COLUMNS = [
    {
        Header: "Name",
        Footer: "Name",
        accessor: "name",
        sticky: "left",
    },
    {
        Header: "Subject",
        Footer: "Subject",
        accessor: "subject",
    },
    {
        Header: "Description",
        Footer: "Description",
        accessor: "description",
    },
    {
        Header: "Date",
        Footer: "Date",
        accessor: "createdAt",
    },
    {
        Header: "Status",
        Footer: "Status",
        accessor: "status",
    },
    {
        Header: "Action",
        Footer: "Action",
        accessor: "action",
    },
];
